import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import classNames from "../../../utils/classNames";
import "./styles.scss";

/**
 * ScrollArea
 * A lightweight, reusable scroll container with a translucent track and
 * gradient thumb. Uses CSS variables for easy theming.
 */
const ScrollArea = forwardRef(function ScrollArea(
  { children, className = "", style, role = "region", ariaLabel },
  ref
) {
  return (
    <div
      ref={ref}
      className={classNames("scroll-area", className)}
      style={style}
      role={role}
      aria-label={ariaLabel}
    >
      {children}
    </div>
  );
});

ScrollArea.propTypes = {
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  style: PropTypes.object,
  role: PropTypes.string,
  ariaLabel: PropTypes.string,
};

ScrollArea.defaultProps = {
  className: "",
  style: undefined,
  role: "region",
  ariaLabel: undefined,
};

export default ScrollArea;


